export const BuildInfo = {timestamp:1782760035000}
